import React, { useEffect } from "react";
import PropTypes from "prop-types";

import "./taboola.m.css";

const TaboolaAd = ({ container }) => {
  useEffect(() => {
    loadScript();
  }, []);

  const loadScript = () => {
    window._taboola = window._taboola || [];

    _taboola.push({ // eslint-disable-line
      mode: "alternating-thumbnails-a",
      container: "taboola-below-article-thumbnails",
      placement: "Below Article Thumbnails",
      target_type: "mix"
    });
  };

  return (
    <div styleName="ad-wrapper">
      <div id="taboola-below-article-thumbnails" />
    </div>
  );
};

TaboolaAd.propTypes = {
  container: PropTypes.string
};

export default TaboolaAd;
